import { useEffect, useState } from 'react';
import { getDeviceType } from 'shared/utils/device-type.utils';
import { debounce } from 'shared/utils/function.utils';

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const deviceType = getDeviceType();

  useEffect(() => {
    let isMounted = true;

    const handleSize = debounce(() => {
      if (isMounted) {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
    }, 1000);

    handleSize();

    window.addEventListener('resize', handleSize);
    return () => {
      isMounted = false;
      window.removeEventListener('resize', handleSize);
    };
  }, []);

  return {
    ...windowSize,
    isMobile: deviceType === 'mobile',
    isTablet: deviceType === 'tablet',
    isDesktop: deviceType === 'desktop',
  };
};

export default useWindowSize;
